import { Controller } from "@hotwired/stimulus"

// Revela o conteúdo ao clicar no gatilho: exibe (display:block) e remove a
// classe `show-print`, que o mantinha oculto na tela. Com auto-value true,
// revela automaticamente ao conectar (ex.: quando vem com ?mostrar=1).
export default class extends Controller {
  static targets = ["content"]
  static values = { auto: Boolean }

  connect() {
    if (this.autoValue) this.reveal()
  }

  reveal(event) {
    if (event) event.preventDefault()
    this.contentTarget.style.display = "block"
    this.contentTarget.classList.remove("show-print")
  }
}
